import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import styled from "styled-components";
import pephubLogo from "../Images/pephub-board.svg";

const NAV_HEIGHT = "3.2rem";

const Container = styled.nav`
  position: fixed;
  top: 0;
  left: 0;
  z-index: 140;
  width: 100%;
  height: ${NAV_HEIGHT};
  border-bottom: 1px solid var(--line-mid);
  background: rgba(255, 255, 255, 0.97);
`;

const Inner = styled.div`
  max-width: 1180px;
  height: 100%;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.6rem;
  padding: 0 1rem;
`;

const Brand = styled.img`
  width: auto;
  height: 36px;
  cursor: pointer;
  display: block;
`;

const RightSide = styled.div`
  display: flex;
  align-items: center;
  gap: 0.62rem;

  @media only screen and (max-width: 768px) {
    display: none;
  }
`;

const GhostButton = styled.button`
  border: none;
  background: transparent;
  color: var(--deep-navy);
  font-family: var(--font-display);
  font-size: 0.83rem;
  font-weight: 600;
  padding: 0.22rem 0.28rem;
  border-radius: 0.35rem;
  cursor: pointer;
  transition: color 0.2s ease;

  &:hover {
    color: var(--brand-blue);
  }
`;

const SolidButton = styled.button`
  border: none;
  background: var(--brand-blue);
  color: var(--surface-white);
  font-family: var(--font-display);
  font-size: 0.83rem;
  font-weight: 700;
  padding: 0.36rem 0.64rem;
  border-radius: 0.38rem;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background: var(--brand-blue-strong);
  }
`;

const Hamburger = styled.button`
  display: none;
  width: 1.9rem;
  height: 1.9rem;
  border: 1px solid rgba(59, 99, 247, 0.18);
  border-radius: 0.42rem;
  background: var(--surface-white);
  color: var(--deep-navy);
  align-items: center;
  justify-content: center;
  font-size: 1rem;
  font-weight: 700;
  cursor: pointer;

  @media only screen and (max-width: 768px) {
    display: inline-flex;
  }
`;

const MobileBackdrop = styled.button`
  display: none;

  @media only screen and (max-width: 768px) {
    display: ${(props) => (props.open ? "block" : "none")};
    position: fixed;
    inset: 0;
    top: ${NAV_HEIGHT};
    border: none;
    background: rgba(17, 36, 75, 0.24);
    z-index: 138;
  }
`;

const MobileMenu = styled.div`
  display: none;

  @media only screen and (max-width: 768px) {
    display: ${(props) => (props.open ? "grid" : "none")};
    position: fixed;
    top: ${NAV_HEIGHT};
    left: 0.5rem;
    right: 0.5rem;
    z-index: 139;
    background: var(--surface-white);
    border: 1px solid var(--line-mid);
    border-radius: 0.55rem;
    box-shadow: 0 10px 22px rgba(18, 43, 92, 0.12);
    padding: 0.45rem;
    gap: 0.25rem;
  }
`;

const MobileItem = styled.button`
  border: none;
  background: transparent;
  text-align: left;
  width: 100%;
  color: var(--deep-navy);
  font-size: 0.86rem;
  font-weight: 600;
  padding: 0.5rem 0.55rem;
  border-radius: 0.38rem;
  cursor: pointer;

  &:hover {
    background: var(--ice-blue);
  }
`;

const MobileItemPrimary = styled(MobileItem)`
  background: var(--brand-blue);
  color: var(--surface-white);

  &:hover {
    background: var(--brand-blue-strong);
  }
`;

const IndexNav = () => {
  const history = useHistory();
  const [mobileOpen, setMobileOpen] = useState(false);
  const hasToken = Boolean(localStorage.getItem("token"));

  const go = (route) => {
    setMobileOpen(false);
    history.push(route);
  };

  return (
    <>
      <Container>
        <Inner>
          <Brand src={pephubLogo} alt="PepHub Boards" onClick={() => go("/")} />
          <RightSide>
            <GhostButton onClick={() => go("/reviews")}>Reviews</GhostButton>
            <GhostButton onClick={() => go("/feedback")}>Feedback</GhostButton>
            {!hasToken && <GhostButton onClick={() => go("/login")}>Sign in</GhostButton>}
            <SolidButton onClick={() => go(hasToken ? "/boards" : "/register")}>
              {hasToken ? "Boards" : "Start free"}
            </SolidButton>
          </RightSide>
          <Hamburger onClick={() => setMobileOpen((prev) => !prev)} aria-label="Toggle menu">
            {mobileOpen ? "x" : "\u2630"}
          </Hamburger>
        </Inner>
      </Container>
      <MobileMenu open={mobileOpen}>
        <MobileItem onClick={() => go("/reviews")}>Reviews</MobileItem>
        <MobileItem onClick={() => go("/feedback")}>Feedback</MobileItem>
        {!hasToken && <MobileItem onClick={() => go("/login")}>Sign in</MobileItem>}
        <MobileItemPrimary onClick={() => go(hasToken ? "/boards" : "/register")}>
          {hasToken ? "Go to Boards" : "Start free"}
        </MobileItemPrimary>
      </MobileMenu>
      <MobileBackdrop open={mobileOpen} onClick={() => setMobileOpen(false)} aria-label="Close menu" />
    </>
  );
};

export default IndexNav;
